/* <![CDATA[ */
document.addEventListener( 'wpcf7mailsent', function( event ) {
    console.log(event.detail);
    if ( '11732' == event.detail.contactFormId || '11761' == event.detail.contactFormId || '11749' == event.detail.contactFormId ) {
        jQuery(".cf-sedction, #hide-send-form").hide();
    }

}, false );
document.addEventListener( 'geo.set', () => {
    console.log( 'RUN geo.set' );
});


window.RW = window.RW || {};
let geoStorage = localStorage.getItem('geo');
const geoVer = localStorage.getItem('geo_v');
let geoTTL = localStorage.getItem('geo_ttl');

const ver = '0.2.5';

if (geoVer != ver) {
    localStorage.setItem('geo_v', ver);
    localStorage.setItem('geo', '');
    geoStorage = false;
}

const parsed = parseInt(geoTTL);
if (isNaN(parsed)) { geoTTL = 0; }
const time = new Date().getTime();


if (!geoTTL) {

    localStorage.setItem('geo_ttl', time);
    geoStorage = false;

}  else {
    const delta = time - geoTTL;

    if (delta > 86400000) {
        localStorage.setItem('geo_ttl', time);
        geoStorage = false;
    }

}


if (geoStorage) {
    setGeoToGlobal(geoStorage);
} else {
    /*
    fetch('https://qawerk.com/geoapi/', {
        headers: {
            'Accept-Language': 'en'
    },
    })
    .then(res => {
        console.log('res', res)
        return res.json();
    })
    .then((data) => {

        if (data.ip && data.country_name && data.country_code) {

            let storageRW = {};
            storageRW.ip = data.ip;
            storageRW.countryCode = data.country_code;
            storageRW.countryName = data.country_name;
            storageRW.res = data;

            storageRW = JSON.stringify(storageRW);
            localStorage.setItem('geo', storageRW );
            setGeoToGlobal(storageRW);
        } else {


        }
    });
    */

    fetch('https://api.db-ip.com/v2/free/self')
        .then(res => {
            return res.json();
        })
        .then((data) => {

            if (data.error || data.errorCode) {

                fetch('https://geo.ipify.org/api/v1?apiKey=at_6ZqAmZ7oX9NzjprgrCAn1DNbm82HC')
                    .then(res => {
                        return res.json();
                    })
                    .then(data => {

                        if (data.ip && data.location.country) {
                            let storageRW = {};
                            storageRW.ip = data.ip;
                            storageRW.countryCode = data.location.country;
                            storageRW.countryName = data.location.country;

                            storageRW = JSON.stringify(storageRW);
                            localStorage.setItem('geo', storageRW );
                            setGeoToGlobal(storageRW);
                        }
                    });

            } else {
                let storageRW = {};
                storageRW.ip = data.ipAddress;
                storageRW.countryCode = data.countryCode;
                storageRW.countryName = data.countryName;

                storageRW = JSON.stringify(storageRW);
                localStorage.setItem('geo', storageRW );
                setGeoToGlobal(storageRW);
            }
        });

}

function setGeoToGlobal(geoString) {
    const geoArray = JSON.parse(geoString);
    RW.ip = geoArray.ip;
    RW.countryCode = geoArray.countryCode;
    RW.countryName = geoArray.countryName;
    document.getElementById('user-country').value = RW.countryName;
    document.dispatchEvent( new Event('geo.set') );
}
/* ]]> */